"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Shapes: function() {
        return Shapes;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Shapes = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1 2C1 1.44772 1.44772 1 2 1H10C10.5523 1 11 1.44772 11 2V10C11 10.5523 10.5523 11 10 11H2C1.44772 11 1 10.5523 1 10V2ZM3 3V9H9V3H3ZM18 1C18.3788 1 18.725 1.214 18.8944 1.55279L22.8944 9.55279C23.0494 9.86277 23.0329 10.2309 22.8507 10.5257C22.6684 10.8205 22.3466 11 22 11H14C13.6534 11 13.3316 10.8205 13.1493 10.5257C12.9671 10.2309 12.9506 9.86277 13.1056 9.55279L17.1056 1.55279C17.275 1.214 17.6212 1 18 1ZM15.618 9H20.382L18 4.23607L15.618 9ZM6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21C7.65685 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15ZM1 18C1 15.2386 3.23858 13 6 13C8.76142 13 11 15.2386 11 18C11 20.7614 8.76142 23 6 23C3.23858 23 1 20.7614 1 18ZM13 14C13 13.4477 13.4477 13 14 13H22C22.5523 13 23 13.4477 23 14C23 14.5523 22.5523 15 22 15H14C13.4477 15 13 14.5523 13 14ZM13 18C13 17.4477 13.4477 17 14 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H14C13.4477 19 13 18.5523 13 18ZM13 22C13 21.4477 13.4477 21 14 21H22C22.5523 21 23 21.4477 23 22C23 22.5523 22.5523 23 22 23H14C13.4477 23 13 22.5523 13 22Z",
        fill: "currentColor"
    })
}), "Shapes");
const _default = Shapes;
